import { render } from "./QuizLoadScreen.vue?vue&type=template&id=74812d61&scoped=true"
import script from "./QuizLoadScreen.vue?vue&type=script&lang=js"
export * from "./QuizLoadScreen.vue?vue&type=script&lang=js"

import "./QuizLoadScreen.vue?vue&type=style&index=0&id=74812d61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74812d61"]])

export default __exports__